export const SupportedLanguages = {
  English: "en",
  German: "de",
  Swedish: "sv",
  Dutch: "nl"
}

export function withLanguage(language) {
  return function getTranslatedValue(translations) {
    return translations[language] ?? translations[SupportedLanguages.English];
  }
}

const languages = {
  "de": {
    "thousandsDelimiter": ".",
    "decimalDelimiter": ",",
    "locale": "de-DE",
    "currency": "eur"
  },
  "sv": {
    "thousandsDelimiter": " ",
    "decimalDelimiter": ",",
    "locale": "sv-SE",
    "currency": "sek"
  },
  "nl": {
    "thousandsDelimiter": ".",
    "decimalDelimiter": ",",
    "locale": "da-DA",
    "currency": "eur"
  },
  "default": {
    "thousandsDelimiter": ",",
    "decimalDelimiter": ".",
    "locale": "en-US",
    "currency": "usd"
  }
}

export function getLanguageInfo(code) {
  return languages[code] ?? languages.default;
}
